export enum Feature {
	COLLECT_UI_LOGS = 'collect_ui_logs',
	HEADER_TIME_TRACKER = 'header_time_tracker',
	REGISTRATION_DISABLED = 'registration_disabled',
	MAP_VIEW = 'map_view',
	PENDING_ITEMS = 'pending_items',
	PERMISSIONS_ANALYSIS = 'permissions_analysis',
	ANALYTICS_IN_FORMS = 'analytics_in_forms',
	VIRTUAL_COURT = 'virtual_court',
	CALENDAR_EVENTS = 'calendar_events',
	ENTITY_RELATIONS_GRAPH = 'entity_relations_graph',
	ASSISTANT = 'assistant',
	MONITORING_AND_EVALUATION = 'monitoring_and_evaluation',
	PUBLIC_ACCESS_CONFIG = 'public_access',
	SAML_LOGIN_CONFIG = 'saml_login',
	FORGOT_PASSWORD_CONFIG = 'forgot_password_disabled'
}
